import React, { useState, useEffect } from "react";
import toast, { Toaster } from "react-hot-toast";
import { useHistory } from "react-router-dom";
// import { useHistory } from 'react-router-dom';

import { transaksiJurnalFormData } from "./transaksiJurnalFormData";
import { transaksiJurnalTable } from "./transaksiJurnalTable";

// Components
import FormCustom from "components/Forms/FormCustom";

// API
import {
  insertNewTransaksiJurnal,
  getDataTableTransaksiJurnal,
  deleteTransaksiJurnal,
  importCSVTransaksiJurnal,
  exportSpesifikTransaksiJurnal,
} from "./api/transaksiJurnalAPI";
import {
  // getDropdownAkunsDebet,
  // getDropdownAkuns,
  getDropdownKodeAkun,

  // getDropdownAkunsKredit,
} from "views/admin/masterData/kodeAkun/api/kodeAkunAPI";
import CardTable from "components/Cards/CardTable";
import ConfirmModal from "components/Modal/ConfirmModal";
import UploadFileModal from "components/Modal/UploadFileModal";
import { TransaksiJurnalSorting } from "./transaksiJurnalSortingData";
import ShowDetailModal from "components/Modal/ShowDetailModal";
import ExcelExport from "components/Exports/ExcelExport";

export default function TransaksiJurnal() {
  const history = useHistory();

  const [dataTable, setDataTable] = useState(false);
  const [pageNumber, setPageNumber] = useState(0);

  const [typeSearch, setTypeSearch] = useState("");

  const [active, setActive] = useState(false);

  const tanggalSaatIni = new Date().toISOString().slice(0, 10);
  const [formData, setFormData] = useState({
    tanggal_transaksi: tanggalSaatIni,
  });

  // Select - Option Data
  const [dropdownAkunDebet, setDropdownAkunDebet] = useState([]);
  const [dropdownAkunKredit, setDropdownAkunKredit] = useState([]);
  // const [dropdownUnitUsaha, setDropdownUnitUsaha] = useState([]);

  const [formDataArr, setFormDataArr] = useState([]);

  const [isLoading, setIsLoading] = useState(false);

  const [result, setResult] = useState(null);
  const [errors, setErrors] = useState(null);

  const [addForm, setAddForm] = useState(false);

  const [deletePopUp, setDeletePopUp] = useState({ show: false, id: null });
  const [showDetailPopUp, setShowDetailPopUp] = useState({
    show: false,
    id: null,
    data: null,
  });

  const [showUploadCSVPopUp, setShowUploadCSVPopUp] = useState([
    {
      show: false,
      id: null,
      data: null,
    },
  ]);

  const [uploadedCSVFile, setUploadedCSVFile] = useState(null);

  // Sorting Data
  const [sortingData, setSortingData] = useState(0);

  // Sorting Data Arr
  const [sortingDataArr, setSortingDataArr] = useState([]);

  const [dataExport, setDataExport] = useState([]);

  // Component is Active
  useEffect(() => {
    setActive(true);
    return () => {
      setActive(false);
    };
  }, []);

  // Loading
  useEffect(() => {
    if (isLoading === true) {
      toast.loading("Data Diproses...");
    }
  }, [isLoading]);

  useEffect(() => {
    exportSpesifikTransaksiJurnal()
      .then((res) => {
        console.log(res.data);
        setDataExport(res.data.data);
      })
      .catch((err) => {
        setErrors(err);
      });
  }, []);

  // Handle When State Active Changed
  useEffect(() => {
    setIsLoading(true);

    getDataTableTransaksiJurnal(null, sortingData)
      .then((response) => {
        active === true && setDataTable(response.data.data);
      })
      .catch((error) => console.error(`Error: ${error}`))
      .finally(setIsLoading(false));

    return () => {
      setDataTable([]);
    };
  }, [active, sortingData]);

  // Clear Form Data When First Time Load Component
  useEffect(() => {
    setFormData({
      tanggal_transaksi: tanggalSaatIni,
    });
  }, [tanggalSaatIni]);

  // Load Data Table
  useEffect(() => {
    if (active === true) {
      setIsLoading(true);
      getDataTableTransaksiJurnal(null, sortingData)
        .then((response) => {
          setDataTable(response.data.data);
        })
        .catch((error) => console.error(`Error: ${error}`))
        .finally(setIsLoading(false));
    }
  }, [active, sortingData]);

  // Handle Search
  const handleSearch = (e) => {
    setTypeSearch(e.target.value);
  };

  // Handle when searching changes
  useEffect(() => {
    const getDataSearchResult = () => {
      getDataTableTransaksiJurnal(typeSearch, sortingData)
        .then((response) => {
          setDataTable(response.data.data);
        })
        .catch((error) => console.error(`Error: ${error}`))
        .finally(setIsLoading(false));
      setPageNumber(0);
    };

    const getData = () => {
      getDataTableTransaksiJurnal(null, sortingData)
        .then((response) => {
          setDataTable(response.data.data);
        })
        .catch((error) => console.error(`Error: ${error}`))
        .finally(setIsLoading(false));
      setPageNumber(0);
    };

    let timer = setTimeout(() => {
      if (typeSearch) {
        getDataSearchResult();
      } else {
        getData();
      }
    }, 1000);

    return () => clearTimeout(timer);
  }, [sortingData, typeSearch]);

  // Handle when Page Change
  const changePage = ({ selected }) => {
    setPageNumber(selected);
  };

  // Handle when user want to add new data
  function handleInsert() {
    setActive(false);
    setAddForm(true);
  }

  // Select-Option Data
  // Load Dropdown Akun Debet
  useEffect(() => {
    setIsLoading(true);

    getDropdownKodeAkun()
      .then((response) => {
        setDropdownAkunDebet(response.data.data);
      })
      .catch((err) => setErrors(err))
      .finally(setIsLoading(false));

    return () => {
      setDropdownAkunDebet([]);
    };
  }, [active]);

  // Load Dropdown Akun Kredit
  useEffect(() => {
    setIsLoading(true);

    getDropdownKodeAkun()
      .then((response) => {
        setDropdownAkunKredit(response.data.data);
      })
      .catch((err) => setErrors(err))
      .finally(setIsLoading(false));

    return () => {
      setDropdownAkunKredit([]);
    };
  }, [active]);

  // Load Dropdown Kode Akun
  // useEffect(() => {
  //   setIsLoading(true);

  //   getDropdownUnitUsaha()
  //     .then((response) => {
  //       setDropdownUnitUsaha(response.data.data);
  //     })
  //     .catch((err) => setErrors(err))
  //     .finally(setIsLoading(false));

  //   return () => {
  //     setDropdownUnitUsaha([]);
  //   };
  // }, []);
  // End Select-Option Data

  // Load Form Data Arr
  useEffect(() => {
    setFormDataArr(
      transaksiJurnalFormData(
        dropdownAkunDebet,
        dropdownAkunKredit
        // dropdownUnitUsaha
      )
    );

    return () => {
      setFormDataArr([]);
    };
  }, [dropdownAkunDebet, dropdownAkunKredit]);

  // Set Inputted Data to Form
  const setData = (key, value) => {
    // console.log(formData);
    return setFormData({ ...formData, [key]: value });
  };

  const setCSVFile = (key, value) => {
    return setUploadedCSVFile({ [key]: value });
  };

  // Handle When User Submit New Data
  const handleInsertSubmit = (e) => {
    e.preventDefault();

    setIsLoading(true);

    insertNewTransaksiJurnal(formData)
      .then((response) => setResult(response))
      .catch((err) => setErrors(err))
      .finally(() => endSubmitProcess());
  };

  // Handle Import CSV
  const handleSubmitUploadCSV = (e) => {
    e.preventDefault();

    setIsLoading(true);

    const formData = new FormData();

    if (uploadedCSVFile !== null) {
      formData.append(
        "csv_transaksi_jurnal",
        uploadedCSVFile["csv_transaksi_jurnal"]
      );
    }

    importCSVTransaksiJurnal(formData)
      .then((response) => {
        handleCloseUploadCSV();
        setActive(false);
        setResult(response);
      })
      .catch((err) => setErrors(err))
      .finally(() => endSubmitProcess());
  };

  // Handle When User Click Cancel
  const handleCancelButton = () => {
    setAddForm(false);
    setFormData(null);
    setActive(true);
  };

  // Handle when user Click import CSV
  const handleUploadCSV = () => {
    setShowUploadCSVPopUp({
      show: true,
      id: null,
      data: null,
    });
  };

  // Handle when User click Close import CSV
  const handleCloseUploadCSV = () => {
    setShowUploadCSVPopUp({
      show: false,
      id: null,
      data: null,
    });
  };

  // Handle When Submit Process is End
  const endSubmitProcess = () => {
    setDeletePopUp({ show: false });

    setIsLoading(false);
  };

  // Check if Request is Failed
  useEffect(() => {
    if (errors !== null) {
      toast.error(errors.message);
    }
  }, [errors]);

  // Check if request is Success
  useEffect(() => {
    if (result !== null) {
      if (result.data.success === true) {
        toast.success(result.data.message);
        setFormData(null);
        setAddForm(false);
        setActive(true);
        history.push("/transaction/transaksiJurnal");
      } else {
        let numericArray = [];
        for (let err in result.data.errors) {
          numericArray.push(result.data.errors[err]);
        }

        if (numericArray.length > 0) {
          toast.error(numericArray[0]);
        }
      }
      setResult(null);
    }

    return () => {
      setResult(null);
    };
  }, [history, result]);

  // Handle when user click delete button
  const handleDelete = (rowData) => {
    setDeletePopUp({
      show: true,
      id: rowData.id_transaksi_jurnal,
    });
  };

  // Handle when user confirm to delete data
  const handleDeleteTrue = () => {
    setActive(false);
    if (deletePopUp.show && deletePopUp.id) {
      setIsLoading(true);

      deleteTransaksiJurnal(deletePopUp.id)
        .then((response) => setResult(response))
        .catch((err) => setErrors(err))
        .finally(() => endSubmitProcess());
    }
  };

  // Handle when user deny to confirm delete data
  const handleDeleteFalse = () => {
    setDeletePopUp({ show: false });
  };

  // Handle when user click show detail button
  function handleShowDetail(rowData) {
    setShowDetailPopUp({
      show: true,
      id: rowData.id_transaksi_jurnal,
      data: rowData,
    });
  }

  // Handle when user want to close show detail modal
  const handleCloseShowDetail = () => {
    setShowDetailPopUp({
      show: false,
      id: null,
      data: null,
    });
  };

  // Load Data Sorting
  useEffect(() => {
    setSortingDataArr(TransaksiJurnalSorting());

    return () => {
      setSortingDataArr([]);
    };
  }, []);

  // Handle when User Click Button Sort Data
  const handleSorting = () => {
    if (sortingData !== null) {
    }
  };

  // Handle when User Click Button Reset Sort Data
  // const handleResetSorting = () => {
  //   console.log("ok");
  // };

  if (addForm === true)
    return (
      <div>
        <div className="flex flex-wrap mt-4">
          <div className="w-full mb-12 px-4">
            <Toaster />
            <FormCustom
              title={"Tambah Data Transaksi Jurnal"}
              formDataArr={formDataArr}
              handleSubmit={handleInsertSubmit}
              handleCancelButton={handleCancelButton}
              setData={setData}
              editFormValue={null}
            />
          </div>
        </div>
      </div>
    );

  return (
    <div>
      <div className="flex flex-wrap mt-4">
        <div className="w-full mb-12 px-4">
          <div className="grid">
            {showUploadCSVPopUp.show && (
              <div>
                <UploadFileModal
                  handleSubmit={handleSubmitUploadCSV}
                  handleClose={(e) => handleCloseUploadCSV()}
                  setFile={setCSVFile}
                  name="csv_transaksi_jurnal"
                  fileExtensions="csv"
                />
              </div>
            )}
            {deletePopUp.show && (
              <div>
                <ConfirmModal
                  handleIfTrue={(e) => handleDeleteTrue()}
                  handleIfFalse={(e) => handleDeleteFalse()}
                />
              </div>
            )}
            {showDetailPopUp.show && (
              <div>
                <ShowDetailModal
                  handleClose={(e) => handleCloseShowDetail()}
                  detailData={showDetailPopUp.data}
                />
              </div>
            )}
          </div>
          <Toaster />
          <CardTable
            tableTitle="Tabel Transaksi Jurnal"
            cols={transaksiJurnalTable(handleDelete, handleShowDetail)}
            handleInsert={(e) => handleInsert()}
            data={dataTable}
            handleSearch={handleSearch}
            pageNumber={pageNumber}
            changePage={changePage}
            importCSVButton={true}
            handleUploadCSV={handleUploadCSV}
            handleSorting={(e) => handleSorting()}
            // handleResetSorting={(e) => handleResetSorting()}
            sortingDataArr={sortingDataArr}
            setDataSorting={setSortingData}
            exportCSVButton={true}
          />
          {dataExport.length > 0 && (
            <div className="py-2 px-4 hidden">
              <ExcelExport
                excelData={dataExport}
                fileName={"Transaksi_jurnal"}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
